<template>
  <SmartLinkItemComponent
    :id="model.system.id"
    custom-tag="div"
    class="content-alert-block"
    :component="!model.system.workflow"
  >
    <SmartLinkStandaloneElement
      custom-tag="div"
      :class="alertStyling"
      :codename="typ.elements.alert_text.codename"
    >
      <font-awesome v-if="alertIcon" class="alert-icon fa-fw" :icon="alertIcon" />
      <div class="alert-text">
        <RichText :value="data.alertText" />
      </div>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import { contentTypes } from '~/models'
import type { ContentAlertBlockModel } from '~/models'
const typ = contentTypes.content_alert_block

const props = defineProps<{ model: ContentAlertBlockModel }>()

const data = {
  alertText: props.model.elements.alertText.value,
  styling: firstOrDefault(props.model.elements.styling.value)
}

const alertIcon = computed(() => {
  const map = new Map<string, string>([
    ['red', 'square-xmark'],
    ['yellow', 'triangle-exclamation'],
    ['green', 'square-check']
  ])

  if (data.styling?.codename) {
    return map.get(data.styling.codename)!
  }

  return ''
})

const alertStyling = computed(() => {
  const map = new Map<string, string>([
    ['red', 'danger'],
    ['yellow', 'warning'],
    ['green', 'success']
  ])

  if (data.styling?.codename) {
    return map.get(data.styling.codename)!
  }

  return ''
})
</script>
